import { ls } from "@/utils/cache";
import {
  USERINFO,
  WECHATUSERINFO,
  COMPANYCODE,
  RESTARUANTINFO,
} from "@/store/mutation-types";
import { jump } from "@/utils/common";
import {
  getRedirectFullUrl,
  getUserInfoCallback,
  refreshToken,
} from "@/api/auth.js";
import restaurantApi from "@/api/restaurant.js";
const user = {
  state: {
    info: {},
    messageCount: 0,
    wechatUserInfo: {},
    companyCode: "",
    restaruantInfo: {},
  },

  mutations: {
    SET_INFO: (state, info) => {
      state.info = info;
    },
    SET_MESSAGECOUNT: (state, count) => {
      state.messageCount = count;
    },
    SET_WECHATUSERINFO: (state, count) => {
      state.wechatUserInfo = count;
    },
    SET_COMPANYCODE: (state, code) => {
      state.companyCode = code;
    },
    SET_RESTARUANTINFO: (state, info) => {
      state.restaruantInfo = info;
    },
  },
  actions: {
    setUserInfo({ commit }, info) {
      ls.set(USERINFO, info);
      commit("SET_INFO", info);
    },
    setWechatUserInfo({ commit }, info) {
      ls.set(WECHATUSERINFO, info);
      commit("SET_WECHATUSERINFO", info);
    },
    setRestaruantInfo({ commit }, info) {
      ls.set(RESTARUANTINFO, info);
      commit("SET_RESTARUANTINFO", info);
    },
    logout({ commit }) {
      commit("SET_INFO", {});
      ls.set(USERINFO, {});
      jump("login");
    },
    getNewToken({ commit }) {
      return new Promise((resolve, reject) => {
        refreshToken()
          .then(res => {
            ls.set(USERINFO, res.Data);
            commit("SET_INFO", res.Data);
            resolve(res);
          })
          .catch(() => {
            reject();
          });
      });
    },
    login({ commit }, to) {
      return new Promise((resolve, reject) => {
        const code = to.query.code;
        const companyCode = to.query.companyCode;
        let url = window.location.href;
        if (versionConfig.ZHIYUN_VERSION && versionConfig.WECHAT_AUTHORURL) {
          url =
            versionConfig.WECHAT_AUTHORURL +
            window.location.pathname +
            window.location.search;
        }
        if (!code) {
          getRedirectFullUrl({
            ReturnUrl: url,
            IsZYPlus: versionConfig.ZHIYUN_VERSION,
            CompanyCode: companyCode,
          })
            .then(res => {
              window.location.href = res.Data;
            })
            .catch(() => {
              reject();
            });
        } else {
          getUserInfoCallback({
            Code: code,
            KeyId: 1,
            IsZYPlus: versionConfig.ZHIYUN_VERSION,
            CompanyCode: companyCode,
          })
            .then(res => {
              const json = {
                ...res.Data,
                ...res.Data.Token,
                fromUrl: url,
              };
              ls.set(USERINFO, json, 48 * 3600 * 1000);
              commit("SET_INFO", json);
              resolve(res);
            })
            .catch(() => {
              reject();
            });
        }
      });
    },
    getTableToken({ commit }, to) {
      return new Promise((resolve, reject) => {
        const tableId = to.TableId ? to.TableId : to.OldTableId;
        const companyCode = to.companyCode ? to.companyCode : to.OldCompanyCode;
        if (tableId || companyCode) {
          restaurantApi
            .getTableToken({ TableId: tableId, CompanyCode: companyCode })
            .then(res => {
              const json = {
                ...res.Data,
                TableId: tableId,
                CompanyCode: companyCode,
              };
              // ls.set(USERINFO, json);
              // commit("SET_INFO", json);
              ls.set(RESTARUANTINFO, json);
              commit("SET_RESTARUANTINFO", json);
              resolve();
            })
            .catch(() => {
              reject();
            });
        } else {
          reject();
        }
      });
    },
    setMessageCount({ commit }, name) {
      commit("SET_MESSAGECOUNT", name);
    },
    setCompanyCode({ commit }, info) {
      ls.set(COMPANYCODE, info);
      commit("SET_COMPANYCODE", info);
    },
  },
};

export default user;
